import _ from 'lodash';
import React, { Component, PropTypes } from 'react';

// Import the CSS
import '../../scss/components/_alert.scss';

export default class Alert extends Component {
	constructor (props) {
		super(props);

		this.state = {
			visible: true
		};
	}

	componentDidMount () {
		if (this.props.dismissTimer) {
			this.setTimer();
		}
	}

	componentWillReceiveProps (nextProps) {
		// Reset the timer upon a new global message
		if (!_.isEqual(nextProps.children, this.props.children) && nextProps.dismissTimer) {
			this.setTimer();
			this.setState({visible: true});
		}
	}

	componentWillUnmount () {
		if (this.props.dismissTimer) {
			clearTimeout(this._timer);
		}
	}

	setTimer () {
		// clear any existing timer
		this._timer != null ? clearTimeout(this._timer) : null;

		// hide after `dismissTimer` milliseconds
		this._timer = setTimeout(function(){
			this.setState({visible: false});
			this._timer = null;
		}.bind(this), this.props.dismissTimer);
	}

	handleClick (e) {
		e.preventDefault();

		if (this.props.onClick) {
			this.props.onClick();
		}
	}

	render () {

		let classes = [ 'alert' ];

		// Add additional classes based on the props
		if (this.props.type) {
			classes.push(`alert-${this.props.type}`);
		}
		if (this.props.style) {
			classes.push(`alert-${this.props.style}`);
		}
		if (this.props.className) {
			classes.push(this.props.className);
		}
		if (this.props.canDismiss) {
			classes.push('alert-dismiss');
		}

		return (
			<If condition={ this.state.visible } >
				<div className={ classes.join(' ') } onClick={ e => this.handleClick(e) }>{ this.props.children }</div>
			</If>
		);
	}

}

Alert.propTypes = {
	type: PropTypes.string,
	style: PropTypes.string,
	canDismiss: PropTypes.bool,
	dismissTimer: PropTypes.number,
};

Alert.defaultProps = {
	canDismiss: false,
};



// WEBPACK FOOTER //
// ./src/assets/js/components/Alert.js